/* eslint-disable */
/**
 * Browser-side mirror of productconfig-dashboard/lib/personalization-svg.js.
 * Keep the two in sync. The Node-side has its own test suite that locks the
 * geometry — copy the math, don't reinvent it.
 *
 * Exposes `window.GfSvg = { ... }` for use by gf-personalization-v4.js.
 */
(function () {
  'use strict';

  var VALID_SHAPES = ['line', 'arch-top', 'arch-bottom', 'circle', 'slant'];

  var SHAPE_DEFAULTS = {
    'arch-top':    { curvature: 0.35 },
    'arch-bottom': { curvature: 0.35 },
    'circle':      { radiusPct: 0.45, startAngleDeg: -90, sweepDeg: 180 },
    'slant':       { slantDeg: -12 }
  };

  function shapeOf(layout) {
    if (!layout || !layout.shape) return 'line';
    return VALID_SHAPES.indexOf(layout.shape) !== -1 ? layout.shape : 'line';
  }

  function withShapeDefaults(layout) {
    var shape = shapeOf(layout);
    var defaults = SHAPE_DEFAULTS[shape] || {};
    var out = {};
    for (var k in defaults) out[k] = defaults[k];
    for (var k2 in layout) out[k2] = layout[k2];
    return out;
  }

  function clamp01(n) {
    if (typeof n !== 'number' || isNaN(n)) return 0;
    return Math.max(0, Math.min(1, n));
  }

  function buildArchPathD(box, curvature, direction) {
    var c = clamp01(curvature == null ? SHAPE_DEFAULTS['arch-top'].curvature : curvature);
    var dir = direction === 'bottom' ? 'bottom' : 'top';
    var yBaseline = dir === 'top' ? box.y + box.h * 0.78 : box.y + box.h * 0.22;
    var xStart = box.x;
    var xEnd = box.x + box.w;
    var bow = c * box.h * 0.8;
    var yPeak = dir === 'top' ? yBaseline - bow : yBaseline + bow;
    var c1x = box.x + box.w / 3;
    var c2x = box.x + (box.w * 2) / 3;
    return 'M ' + xStart + ' ' + yBaseline + ' C ' + c1x + ' ' + yPeak + ', ' + c2x + ' ' + yPeak + ', ' + xEnd + ' ' + yBaseline;
  }

  function buildCirclePathD(box, radiusPct, startAngleDeg, sweepDeg) {
    var defs = SHAPE_DEFAULTS.circle;
    var radius = (radiusPct == null ? defs.radiusPct : radiusPct) * Math.min(box.w, box.h);
    var sa = (startAngleDeg == null ? defs.startAngleDeg : startAngleDeg) * Math.PI / 180;
    var sw = (sweepDeg == null ? defs.sweepDeg : sweepDeg) * Math.PI / 180;
    var cx = box.x + box.w / 2;
    var cy = box.y + box.h / 2;
    var x1 = cx + radius * Math.cos(sa);
    var y1 = cy + radius * Math.sin(sa);
    var x2 = cx + radius * Math.cos(sa + sw);
    var y2 = cy + radius * Math.sin(sa + sw);
    var sweepRaw = sweepDeg == null ? defs.sweepDeg : sweepDeg;
    var largeArc = Math.abs(sweepRaw) > 180 ? 1 : 0;
    var sweepFlag = sweepRaw >= 0 ? 1 : 0;
    return 'M ' + x1 + ' ' + y1 + ' A ' + radius + ' ' + radius + ' 0 ' + largeArc + ' ' + sweepFlag + ' ' + x2 + ' ' + y2;
  }

  function buildSlantTransform(cx, cy, slantDeg) {
    var deg = slantDeg == null ? SHAPE_DEFAULTS.slant.slantDeg : slantDeg;
    return 'translate(' + cx + ' ' + cy + ') skewX(' + deg + ') translate(' + (-cx) + ' ' + (-cy) + ')';
  }

  function resolveFieldGeometry(mockupAnchorBox, layout, viewBox) {
    var VB = viewBox || 1000;
    var boxAbs = {
      x: mockupAnchorBox.x * VB,
      y: mockupAnchorBox.y * VB,
      w: mockupAnchorBox.w * VB,
      h: mockupAnchorBox.h * VB
    };
    var cx = boxAbs.x + layout.x * boxAbs.w;
    var cy = boxAbs.y + layout.y * boxAbs.h;
    var fontSize = boxAbs.h * (layout.fontSizePct || 0.5);
    return { cx: cx, cy: cy, fontSize: fontSize, boxAbs: boxAbs };
  }

  window.GfSvg = {
    VALID_SHAPES: VALID_SHAPES,
    SHAPE_DEFAULTS: SHAPE_DEFAULTS,
    shapeOf: shapeOf,
    withShapeDefaults: withShapeDefaults,
    buildArchPathD: buildArchPathD,
    buildCirclePathD: buildCirclePathD,
    buildSlantTransform: buildSlantTransform,
    resolveFieldGeometry: resolveFieldGeometry,
    clamp01: clamp01
  };
})();
